var exports = {
  "d": "x127c5a35--2ae4e4--read_more",
  "K": "x127c5a35--2ae4e4--icon",
};

module.exports = exports;
